import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {};
const preferencesFromJSON = ({
  attributes,
  sort,
  per_page,
  custom_preferences,
  order
}) => ({
  attributes,
  sort: sort ? { attributeId: sort.field, direction: sort.order } : void 0,
  perPage: per_page,
  customPreferences: custom_preferences,
  order
});
const fetchUserLayoutPreferences = (entityId) => fetch("GET", qualifyUrl(`/entitylists/preferences/${entityId}`)).then((res) => preferencesFromJSON(res != null ? res : {}));
const useUserLayoutPreferences = (entityId) => {
  const { data, isInitialLoading, refetch } = useQuery({
    queryKey: ["table-layout", entityId],
    queryFn: () => defaultOnError(
      fetchUserLayoutPreferences(entityId),
      `Loading layout preferences for "${entityId}" overview failed with`
    ),
    placeholderData: keepPreviousData,
    // 1 hour
    staleTime: 60 * (60 * 1e3)
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isInitialLoading,
    refetch
  };
};
export default useUserLayoutPreferences;
